import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import baseUrl from "../../BaseUrl";
import axios from 'axios';

const ApiSecretGeneration = ({baseData, updatedTNSDetail}) => {
    // console.log(baseData);
    const [copied, setCopied] = useState(false);
    const [countUpdated, setCountUpdated] = useState(false)
    const [inputIp, setInputIp] = useState('')
    const [formData, setFormData] = useState({
        cid: '',
        email: "",
        api_enable_switch: false,
        api_access_count:null,
        api_username:'',
        api_secret:"",
        api_daily_switch : false,
        api_daily_access_count: '',
        capi_daily_usage_switch: false,  
        capi_daily_usage_count: '',  
        capi_monthly_number_order_count: '',  
        enable_bap_api: false,
        enable_tns_api: false,
        enable_call_pass_api: false,
        enable_enrms_api: false,
        allowed_api_access_ips: [],
    });
    useEffect(() => {
        if(baseData){
            const apiKey = uuidv4();
            setFormData((prevData) => ({
                ...prevData,
                cid: baseData.cid,
                email: baseData.email,
                api_enable_switch : baseData.api_enable_switch ?? false,
                api_access_count:baseData.api_access_count ?  baseData.api_access_count : 1000,
                api_username: baseData?.api_username ?? apiKey,
                api_secret: baseData.api_secret,
                api_daily_switch : baseData.api_daily_switch ?? true,
                api_daily_access_count: baseData.api_daily_access_count ? baseData.api_daily_access_count : 100,
                capi_daily_usage_switch : baseData.capi_daily_usage_switch ?? true,
                capi_daily_usage_count: baseData.capi_daily_usage_count ? baseData.capi_daily_usage_count : 100,
                capi_monthly_number_order_count: baseData.capi_monthly_number_order_count ? baseData.capi_monthly_number_order_count : 100,
                enable_bap_api : baseData.enable_bap_api ?? true,
                enable_tns_api : baseData.enable_tns_api ?? true,
                enable_call_pass_api: baseData.enable_call_pass_api ?? false,
                enable_enrms_api: baseData.enable_enrms_api ?? false,
                allowed_api_access_ips: baseData.allowed_api_access_ips ?? []
            }));
        }
    }, [baseData]);

    // useEffect(() => {
    //     console.log(formData)
    // }, [formData]);
    
    // const handleSaveApiAccessCount = async (event) => {
    //     setFormData((prevData)=> ({
    //         ...prevData,
    //         api_access_count: event.target.value
    //     }))
    //     try {
    //         const response = await axios.post(`${baseUrl}/api-access-count`, {
    //           formData: {cid:formData.cid, api_access_count: formData.api_access_count}             
    //         });
    //         if(response.data.status === 'updated'){
    //             setCountUpdated(true)
    //             setTimeout(() => setCountUpdated(false), 2000); // Reset after 2 seconds
    //         }
    //       } catch (error) {
    //         console.error('Error fetching data:', error);
    //       }
    // }
    
    const handleE911SwitchChange = async(event) => {
        const { name, checked } = event.target;
        console.log(name);
        console.log(checked);


        setFormData((prevData) => ({
            ...prevData,
            [name]: checked,
        }));
        // if(checked){
        //     if(window.confirm("Are you sure you want to enable API access for this customer ?")){
        //         setFormData((prevData) => ({
        //             ...prevData,
        //             [name]: checked,

        //         })); 
        //         // try {
        //         //   const response = await axios.post(`${baseUrl}/cognito-user-detail`, {
        //         //     formData: { ...formData, [name]: checked, api_secret: api_secret }             
        //         //   });
        //         //   console.log('Response:', response.data);
        //         // } catch (error) {
        //         //   console.error('Error fetching data:', error);
        //         // }
        //     } 
        // }else{
        //     setFormData((prevData) => ({
        //         ...prevData,
        //         [name]: checked,
        //         api_enable_switch:checked
        //     }));
        //     // try {
        //     //     const response = await axios.post(`${baseUrl}/cognito-user-detail`, {
        //     //       formData: { ...formData, [name]: checked, api_secret: "",api_access_count:null }             
        //     //     });
        //     //     console.log('Response:', response.data);
        //     //   } catch (error) {
        //     //     console.error('Error fetching data:', error);
        //     //   }
        // }
    };
    const generatePassword = () => {
        const length = 25;
        const numbers = '0123456789';
        const lowerCase = 'abcdefghijklmnopqrstuvwxyz';
        const upperCase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const specialCharacters = '^$*.[]{}()?-@#%&/,><|_~+=';
    
        const allCharacters = numbers + lowerCase + upperCase + specialCharacters;
    
        let password = '';
        let hasNumber = false;
        let hasLowerCase = false;
        let hasUpperCase = false;
        let hasSpecialCharacter = false;
    
        // Ensure the password contains at least one of each required character type
        password += numbers[Math.floor(Math.random() * numbers.length)];
        hasNumber = true;
    
        password += lowerCase[Math.floor(Math.random() * lowerCase.length)];
        hasLowerCase = true;
    
        password += upperCase[Math.floor(Math.random() * upperCase.length)];
        hasUpperCase = true;
    
        password += specialCharacters[Math.floor(Math.random() * specialCharacters.length)];
        hasSpecialCharacter = true;
    
        // Fill the rest of the password length with random characters
        for (let i = password.length; i < length; i++) {
            const character = allCharacters[Math.floor(Math.random() * allCharacters.length)];
            password += character;
    
            if (numbers.includes(character)) {
                hasNumber = true;
            } else if (lowerCase.includes(character)) {
                hasLowerCase = true;
            } else if (upperCase.includes(character)) {
                hasUpperCase = true;
            } else if (specialCharacters.includes(character)) {
                hasSpecialCharacter = true;
            }
        }
    
        // Shuffle the password to ensure randomness
        password = password.split('').sort(() => Math.random() - 0.5).join('');
    
        // Validate the generated password and regenerate if it doesn't meet all criteria
        if (!hasNumber || !hasLowerCase || !hasUpperCase || !hasSpecialCharacter) {
            return generatePassword();
        }
    
        return password;
    };
    const partiallyHideSecret = (secret) => {
        if(secret){
            const visibleChars = 4;
            const hiddenChars = secret.length - visibleChars;
            return `${secret.slice(0, visibleChars)}${'*'.repeat(hiddenChars)}`;
        }else{
           return secret
        }
       
    };

    const handleCopy = async (e, value) => {
        e.preventDefault();
        try {
          await navigator.clipboard.writeText(value);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
        } catch (error) {
          console.error('Failed to copy:', error);
        }
    };

    const handleCapiInputChange = async(e) => {
        const { name, value, type, checked } = e.target;
        console.log(name, value, type, checked);
        // Handle switch and other input changes
        // setFormData((prev) => ({
        //     ...prev,
        //     [name]: type === 'checkbox' ? checked : value,
        // }));

        setFormData((prevSetting) => {
            let updatedFormData = { ...prevSetting };
                const count = formData.capi_daily_usage_count >= 100 ? 100 : formData.capi_daily_usage_count;
                updatedFormData = {
                    ...prevSetting,
                    [name]: checked,
                    "capi_daily_usage_count": count,
                };
            
            updatedTNSDetail(updatedFormData);
            return updatedFormData;
        });
    }

    const handleBapInputChange = async(e) => {
        const { name, value, type, checked } = e.target;
        console.log(name, value, type, checked);
        // Handle switch and other input changes
        // setFormData((prev) => ({
        //     ...prev,
        //     [name]: type === 'checkbox' ? checked : value,
        // }));

        setFormData((prevSetting) => {
            let updatedFormData = { ...prevSetting };
                updatedFormData = {
                    ...prevSetting,
                    [name]: checked,
                };
            
            updatedTNSDetail(updatedFormData);
            return updatedFormData;
        });
    }

    const handleApiDailyInputChange = async(e) => {
        const { name, value, type, checked } = e.target;
        console.log(name, value, type, checked);
       

        setFormData((prevSetting) => {
            let updatedFormData = { ...prevSetting };
            const count = formData.api_daily_access_count >= 100 ? 100 : formData.api_daily_access_count;
            updatedFormData = {
                ...prevSetting,
                [name]: checked,
                "api_daily_access_count": count,
            };
            
            updatedTNSDetail(updatedFormData);
            return updatedFormData;
        });
    }
    
    
    const handleInputChange = async(event) => {
        const { name, checked, value } = event.target;
        
        // if(name === "api_daily_switch"){
        //     const count = formData.api_access_count >= 100 ? 100 : formData.api_access_count;
        //     setFormData((prevSetting) => ({
        //         ...prevSetting,
        //         [name]: checked,
        //         ["api_daily_access_count"] : count
        //     }));
        // }else if(name === "api_daily_access_count"){
        //     if(value > 100 || value > formData.api_access_count){
        //         alert("please set valid daily limit");
        //     }else{
        //         setFormData((prevSetting) => ({
        //             ...prevSetting,
        //             [name]: value,
        //         }));
        //     }
            
        // }else{
        //     setFormData((prevSetting) => ({
        //         ...prevSetting,
        //         [name]: value,
        //     }));
        // }
        setFormData((prevSetting) => {
            let updatedFormData = { ...prevSetting };

            if (name === "api_daily_switch") {
                const count = formData.api_access_count >= 100 ? 100 : formData.api_access_count;
                updatedFormData = {
                    ...prevSetting,
                    [name]: checked,
                    "api_daily_access_count": count,
                };
            } else if (name === "api_daily_access_count") {
                if (value > 100 || value > formData.api_access_count) {
                    alert("please set valid daily limit");
                } else {
                    updatedFormData = {
                        ...prevSetting,
                        [name]: value,
                    };
                }
            } else if (name === "api_access_count") {
                
                updatedFormData = {
                    ...prevSetting,
                    [name]: value,
                    "api_daily_access_count": value > 100 ? 100 : value
                };
                
            }else if (name === "capi_daily_usage_switch") {
                const count = formData.capi_daily_usage_count >= 100 ? 100 : formData.capi_daily_usage_count;
                updatedFormData = {
                    ...prevSetting,
                    [name]: checked,
                    "capi_daily_usage_count": count,
                };
            }else if (name === "capi_daily_usage_count") {
                if (value > 100 || value > formData.capi_daily_usage_count) {
                    alert("please set valid daily limit");
                } else {
                    updatedFormData = {
                        ...prevSetting,
                        [name]: value,
                    };
                }
            }else if (name === "capi_monthly_number_order_count") {
                updatedFormData = {
                    ...prevSetting,
                    [name]: value,
                };
                // if (value > 100 || value > formData.capi_monthly_number_order_count) {
                //     alert("please set valid daily limit");
                // } else {
                //     updatedFormData = {
                //         ...prevSetting,
                //         [name]: value,
                //     };
                // }
            } else if(name === "enable_bap_api"){
                console.log(checked);
                updatedFormData = {
                    ...prevSetting,
                    [name]: checked,
                };
            }
            else if(name === "enable_tns_api"){
                updatedFormData = {
                    ...prevSetting,
                    [name]: checked,
                };

            }if (name === "api_enable_switch") {
                updatedFormData = {
                    ...prevSetting,
                    [name]: checked,
                };
            }else {
                updatedFormData = {
                    ...prevSetting,
                    [name]: value,
                };
            }

            

            updatedTNSDetail(updatedFormData);
            return updatedFormData;
        });
       
        
    };

    const handleToggleEnableCallPassApi = async(e) => {
        const { name, value, type, checked } = e.target;
        console.log(name, value, type, checked);
        // Handle switch and other input changes
        // setFormData((prev) => ({
        //     ...prev,
        //     [name]: type === 'checkbox' ? checked : value,
        // }));

        setFormData((prevSetting) => {
            let updatedFormData = { ...prevSetting };
                updatedFormData = {
                    ...prevSetting,
                    [name]: checked,
                };

            updatedTNSDetail(updatedFormData);
            return updatedFormData;
        });
    }

    const handleToggleEnableEnrmsApi = async(e) => {
        const { name, checked } = e.target;
        console.log(name, checked);

        setFormData((prevSetting) => {
            let updatedFormData = {
                ...prevSetting,
                [name]: checked,
            };

            updatedTNSDetail(updatedFormData);
            return updatedFormData;
        });
    }
    
    const handleIpInputChange = (e) => {
        setInputIp(e.target.value);
    }

    const handleAddIp = async (ip) => {
        setFormData((prevSetting) => {
            let updatedFormData = { ...prevSetting };
                updatedFormData = {
                    ...prevSetting,
                    allowed_api_access_ips: [...updatedFormData.allowed_api_access_ips, ip],
                };
            
            updatedTNSDetail(updatedFormData);
            setInputIp('');
            return updatedFormData;
        });
    }
    
    const handleRemoveIp = async (ip) => {
        setFormData((prevSetting) => {
            let updatedFormData = { ...prevSetting };
                updatedFormData = {
                    ...prevSetting,
                    allowed_api_access_ips: updatedFormData.allowed_api_access_ips.filter(item => item !== ip),
                };
            
            updatedTNSDetail(updatedFormData);
            return updatedFormData;
        });
    }
    
    return (
        <>
        <div className="common-white-shadow-background setting-section">
            <div className="innerboxwidth">
                <div className="row">
                    <div className="settingbox">
                        <label><b>Enable API access</b></label>
                        <div className="switchbtn">
                            <input type="checkbox" id="api_enable_switch" className="checkbox" checked={formData.api_enable_switch === true} name="api_enable_switch" onChange={handleInputChange} /> <label
                                htmlFor="api_enable_switch" className="toggle">
                                <p>
                                    
                                </p>
                            </label>
                        </div>
                        {/* <input type="button" className="yellow-button" value="Generate" onClick={handleGenerate} /> */}
                    </div>
                    
                    {/* <div className="settingbox">
                        <label>Api Access</label>
                        <div className="switchbtn">
                            <input type="checkbox" id="api_enable_switch" className="checkbox" checked={formData.api_enable_switch === true} name="api_enable_switch" onChange={handleInputChange} /> <label
                                htmlFor="api_enable_switch" className="toggle">
                                <p>
                                    
                                </p>
                            </label>
                        </div>
                       
                    </div> */}

                    {formData.api_enable_switch && <div className="settingbox">
                        <label>Allowed IPs</label>
                        <div className="col-sm-2">
                            <input className='mr-2' style={{width: '60%'}} type="text" name="allowed_api_access_ips" placeholder='IP'  value={inputIp} onChange={handleIpInputChange}  />
                            <button disabled={inputIp === '' ? true : false} className={inputIp === '' ? 'disabled-link btn-primary' : 'btn-primary'}      onClick={(e) => {handleAddIp(inputIp)}}>Add</button  >
                        </div>
                    </div>}

                    {/* Display selected countries as tags below the select */}
                    {formData.api_enable_switch && formData.allowed_api_access_ips && formData.allowed_api_access_ips.length > 0 && (
                        <div style={{ marginTop: '5px', marginBottom: '10px', paddingLeft: '15px', paddingRight: '15px' }}>
                            {formData.allowed_api_access_ips.map((ip,index) => (
                                <span key={index} style={{
                                    display: 'inline-block',
                                    backgroundColor: '#e4e4e4',
                                    borderRadius: '12px', // Make them rounded tags
                                    padding: '4px 10px',
                                    margin: '3px', // Add some space between tags
                                    fontSize: '0.85em', // Slightly smaller font
                                    verticalAlign: 'middle' // Align vertically
                                }}>
                                    {ip}
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveIp(ip)}
                                        style={{
                                            marginLeft: '8px', // More space for the 'x'
                                            cursor: 'pointer',
                                            border: 'none',
                                            backgroundColor: 'transparent',
                                            color: '#555', // Darker color for 'x'
                                            fontWeight: 'bold',
                                            padding: '0', // Remove button padding
                                            lineHeight: '1' // Adjust line height
                                        }}
                                    >
                                        x
                                    </button>
                                </span>
                            ))}
                        </div>
                    )}

                    {/* BAP API Configurations */}
                    {formData.api_enable_switch && <div className="settingbox introducebpx">
                        <label><b>Enable BAP API</b></label>
                        <div className="switchbtn">
                            <input type="checkbox" id="enable_bap_api" className="checkbox dmt-type" checked={formData.enable_bap_api === true} name="enable_bap_api" onChange={handleBapInputChange} /> 
                            <label
                                    htmlFor="enable_bap_api" className="toggle">
                                    <p>

                                    </p>
                            </label>
                        </div>
                    </div> } 

                    {(formData.api_enable_switch && formData.enable_bap_api) && <div className="settingbox">
                        <label>Daily API Usage Limit</label>
                        <div className="switchbtn daily-limit">
                            <input type="checkbox" id="capi_daily_usage_switch" className="checkbox dmt-type" checked={formData.capi_daily_usage_switch === true} name="capi_daily_usage_switch" onChange={handleCapiInputChange} /> <label
                                htmlFor="capi_daily_usage_switch" className="toggle">
                                <p>

                                </p>
                            </label>
                            {formData.capi_daily_usage_switch && 
                                <div className="daily-input">
                                    <input 
                                        type="number" 
                                        name="capi_daily_usage_count" 
                                        value={formData.capi_daily_usage_count} 
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }
                        </div>
                    </div> }

                    {(formData.api_enable_switch && formData.enable_bap_api) && <div className="settingbox">
                       <label>DIDs or Toll Free numbers Monthly Usage Limit</label>
                            <div className="col-sm-2">
                                <input style={{width: '60%'}} type="number" name="capi_monthly_number_order_count"  value={formData.capi_monthly_number_order_count} onChange={handleInputChange}  />
                            </div>
                    </div> }

                    {/* TNS(Telephone Number Status) API — removed per BBD request
                    {formData.api_enable_switch && <div className="settingbox">
                        <label><b>Enable TNS(Telephone Number Status) API</b></label>
                        <div className="switchbtn">
                            <input type="checkbox" id="enable_tns_api" className="checkbox dmt-type" checked={formData.enable_tns_api === true} name="enable_tns_api" onChange={handleBapInputChange} /> <label
                                htmlFor="enable_tns_api" className="toggle">
                                <p>

                                </p>
                            </label>
                        </div>
                    </div> }
                    {(formData.api_enable_switch && formData.enable_tns_api) && <div className="settingbox">
                        <label>Monthly Usage Limit (Tel Numbers)</label>
                            <div className="col-sm-2">
                                <input style={{width: '60%'}} type="number" name="api_access_count"  value={formData.api_access_count} onChange={handleInputChange}  />
                            </div>
                    </div> }

                    {(formData.api_enable_switch && formData.enable_tns_api) && <div className="settingbox">
                       <label>Daily Usage Limit (Tel Numbers)</label>
                    <div className="switchbtn daily-limit">
                            <input type="checkbox" id="api_daily_switch" className="checkbox" checked={formData.api_daily_switch === true} name="api_daily_switch" onChange={handleApiDailyInputChange} /> <label
                                htmlFor="api_daily_switch" className="toggle">
                                <p>

                                </p>
                            </label>
                            {formData.api_daily_switch &&
                                <div className="col-sm-2 daily-input">
                                    <input
                                        type="number"
                                        name="api_daily_access_count"
                                        value={formData.api_daily_access_count}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            }
                        </div>
                    </div>}
                    */}

                    {/* Enable Call Pass CDR API Configurations */}
                    {/* {formData.api_enable_switch && <div className="settingbox introducebpx">
                        <label><b>Enable Call Pass API</b></label>
                        <div className="switchbtn">
                            <input type="checkbox" id="enable_call_pass_api" className="checkbox dmt-type" checked={formData.enable_call_pass_api === true} name="enable_call_pass_api" onChange={handleToggleEnableCallPassApi} /> <label
                                htmlFor="enable_call_pass_api" className="toggle">
                                <p>

                                </p>
                            </label>
                        </div>
                    </div> } */}

                    {/* Enable ENRMS API Configurations */}
                    {/* {formData.api_enable_switch && <div className="settingbox introducebpx">
                        <label><b>Enable ENRMS API</b></label>
                        <div className="switchbtn">
                            <input type="checkbox" id="enable_enrms_api" className="checkbox dmt-type" checked={formData.enable_enrms_api === true} name="enable_enrms_api" onChange={handleToggleEnableEnrmsApi} /> <label
                                htmlFor="enable_enrms_api" className="toggle">
                                <p>

                                </p>
                            </label>
                        </div>
                    </div> } */}

                    {/* Enable ENRMS API Configurations */}
                    {formData.api_enable_switch && <div className="settingbox introducebpx">
                        <label><b>Enable ENRMS API</b></label>
                        <div className="switchbtn">
                            <input type="checkbox" id="enable_enrms_api" className="checkbox dmt-type" checked={formData.enable_enrms_api === true} name="enable_enrms_api" onChange={handleToggleEnableEnrmsApi} /> <label
                                htmlFor="enable_enrms_api" className="toggle">
                                <p>

                                </p>
                            </label>
                        </div>
                    </div> }

                    {/* {formData.api_enable_switch && <div className='api-key-secret'>
                        <div className="row">
                            <div className="col-sm-2">
                                <label>Api Key</label>
                            </div>
                            <div className="col-sm-8">
                                <input type="text" name="api_ket" readOnly placeholder="Api Key" value={partiallyHideSecret(formData.api_username)} />
                            </div>
                            <div className="col-sm-2">
                                <input type="button" onClick={(e) => handleCopy(e, formData.api_username)} value="Copy"/>
                               
                            </div>
                            
                        </div>
                        <div className="row">
                            <div className="col-sm-2">
                                <label>Api Secret</label>
                            </div>
                            <div className="col-sm-8">
                                <input type="text" name="api_secret" readOnly placeholder="Api Secret" value={partiallyHideSecret(formData.api_secret)}  />
                            </div>
                            <div className="col-sm-2">
                                <input type="button" onClick={(e) => handleCopy(e, formData.api_secret)} value="Copy"/>
                               
                            </div>
                        </div>
                        {copied && <span>Copied!</span>}
                        {countUpdated && <span>Access Count Updated!</span>}
                    </div>} */}
                </div>
            </div>
        </div>  
        {/* <div className="common-white-shadow-background setting-section">
            <div className="innerboxwidth">
                <div className="row">
                    <div className="header-row">
                        <h3 class="col-sm-5">Enable BAP API</h3>
                        <div className="col-sm-7 switchbtn">
                            <input type="checkbox" id="enable_bap_api" className="checkbox dmt-type" checked={formData.enable_bap_api === true} name="enable_bap_api" onChange={handleBapInputChange} /> <label
                                    htmlFor="enable_bap_api" className="toggle">
                                    <p>

                                    </p>
                                </label>
                        </div>
                    </div>
                    
                    
                    {(formData.api_enable_switch && formData.enable_bap_api) && 
                        <>
                        <div className="settingbox">
                            <label>Daily API Usage Limit</label>
                            <div className="switchbtn daily-limit">
                                <input type="checkbox" id="capi_daily_usage_switch" className="checkbox dmt-type" checked={formData.capi_daily_usage_switch === true} name="capi_daily_usage_switch" onChange={handleCapiInputChange} /> <label
                                    htmlFor="capi_daily_usage_switch" className="toggle">
                                    <p>

                                    </p>
                                </label>
                                {formData.capi_daily_usage_switch && 
                            
                            <div className="col-sm-2 daily-input">
                                <input 
                                    type="number" 
                                    name="capi_daily_usage_count" 
                                    value={formData.capi_daily_usage_count} 
                                    onChange={handleInputChange}
                                />
                            </div>
                        }
                            </div>
                        </div>
                    </>}

                    {(formData.api_enable_switch && formData.enable_bap_api) && <div className="settingbox">
                            <label>DIDs or Toll Free numbers Monthly Usage Limit</label>
                            <div className="col-sm-2">
                                <input style={{width: '60%'}} type="number" name="capi_monthly_number_order_count"  value={formData.capi_monthly_number_order_count} onChange={handleInputChange}  />
                            </div>
                    </div> }
                    
                </div>
            </div>
        </div> */}

        {/* <div className="common-white-shadow-background setting-section">
            <div className="innerboxwidth">
                <div className="row">
                    <div className="header-row">
                        <h3>Enable TNS(Telephone Number Status)  API</h3>

                        <div className="switchbtn">
                            <input type="checkbox" id="enable_tns_api" className="checkbox dmt-type" checked={formData.enable_tns_api === true} name="enable_tns_api" onChange={handleBapInputChange} /> <label
                                htmlFor="enable_tns_api" className="toggle">
                                <p>

                                </p>
                            </label>
                        </div>
                    </div>
                    
                    
                    {(formData.api_enable_switch && formData.enable_tns_api) && <div className="settingbox">
                            <label>Monthly Usage Limit (Tel Numbers)</label>
                            <div className="col-sm-2">
                                <input style={{width: '60%'}} type="number" name="api_access_count"  value={formData.api_access_count} onChange={handleInputChange}  />
                            </div>
                    </div> }
                    {(formData.api_enable_switch && formData.enable_tns_api) && 
                        <>
                        <div className="settingbox">
                            <label>Daily Usage Limit (Tel Numbers)</label>
                            <div className="switchbtn daily-limit">
                                <input type="checkbox" id="api_daily_switch" className="checkbox" checked={formData.api_daily_switch === true} name="api_daily_switch" onChange={handleInputChange} /> <label
                                    htmlFor="api_daily_switch" className="toggle">
                                    <p>

                                    </p>
                                </label>
                                {formData.api_daily_switch && 
                            
                            <div className="col-sm-2 daily-input">
                                <input 
                                    type="number" 
                                    name="api_daily_access_count" 
                                    value={formData.api_daily_access_count} 
                                    onChange={handleInputChange}
                                />
                            </div>
                        }
                            </div>
                        </div>
                       
                    </>}
                    
                </div>
            </div>
        </div> */}
      </>
    );
  };
  
  export default ApiSecretGeneration;